"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const facility_1 = require("./facility");
const residents_1 = require("./residents");
const user_1 = require("./user");
const user_exception_1 = require("./user.exception");
exports.APP_MESSAGES = {
    facility: facility_1.FACILITY_MESSAGES,
    residents: residents_1.RESIDENT_MESSAGES,
    user: user_1.USER_MESSAGES,
    userException: user_exception_1.USER_EXCEPTION_MESSAGES,
};
